import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "install_active",
  "use": "install_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"install_active\"><path fill-rule=\"evenodd\" d=\"M10 12.962 13.679 9H15l-5.5 6L4 9h1.321L9 12.962V4h1v8.962ZM9.5 19a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol